import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (classId, studentId, admit) {
    try {
        const params = { classId, studentId, admit };
        const res = await axios.get(Env.apiPath + "admitStudent", { params });
        return res.data.error;
    } catch (err) {
        return err;
    }
}